/** Stader MaticX (Ethereum home contract) — per-user enumeration.
 *  Address on chain 1:
 *  `0xf03a7eb46d01d9ecaa104558c732cf82f6b6b645`. Polygon
 *  delegation goes through the IStakeManager `withdrawalDelay()`. */
export const StaderMaticxWithdrawalAbi = [
  {
    name: 'getUserWithdrawalRequests',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: '_user' }],
    outputs: [
      {
        type: 'tuple[]',
        components: [
          { type: 'uint256', name: 'amount' },
          { type: 'uint256', name: 'validatorNonce' },
          { type: 'uint256', name: 'requestEpoch' },
          { type: 'address', name: 'validatorAddress' },
        ],
      },
    ],
  },
] as const

/** Polygon IStakeManager — used to compute `readyAt` for MaticX
 *  withdrawals. `epoch()` returns the current Polygon checkpoint,
 *  `withdrawalDelay()` is the unbond duration. */
export const PolygonStakeManagerAbi = [
  {
    name: 'epoch',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'withdrawalDelay',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
